export enum AnimType {
	COPY = 'copy',
}
